
const digest = '7359f97c7ddc885413230dc4a0180df328b647099a94a486148e98bc104deee7';
const classes = {"wrapper":"_wrapper_1c81y_1","red":"_red_1c81y_12"};
const css = `._wrapper_1c81y_1 {
  font-family: Rubik, "sans-serif";
  color: #ffffff;
  border-radius: 10px;
  font-size: 11px;
  padding: 4px 8px 2px 8px;
  background: rgb(23, 101, 216);
  background: linear-gradient(90deg, rgb(23, 101, 216) 0%, rgb(23, 158, 216) 100%);
  font-weight: 600;
  max-width: fit-content;
}
._wrapper_1c81y_1._red_1c81y_12 {
  background: #F12848;
  background: linear-gradient(90deg, rgb(241, 40, 72) 0%, rgb(241, 40, 104) 100%);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  